import styled from "styled-components";
import { InputLabel } from "../InputField/InputLabel";

export const TextAreaLabel = styled(InputLabel)``;
TextAreaLabel.displayName = "TextAreaLabel";
